/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import './styles.css';

import React, { useCallback, useRef, useMemo } from 'react';
import { Modal as DSModal, PlainSelect as Select, Button, Typography } from '@vtblife/uikit';
import { Paginator } from '@vtblife/uikit/legacy';

import { errorCatcherWrap } from '@search/error/src/catcher';
import { ApplicationIdEnum } from '@search/graphql-typings';
import NewBuildingBaseSnippet, {
    NewBuildingBaseSnippetProps
} from '@search/vtbeco-frontend-core/domain/newbuilding/components/desktop/NewBuildingBaseSnippet';
import {
    SnippetProviderContext
} from '@search/vtbeco-frontend-core/domain/newbuilding/components/desktop/NewBuildingBaseSnippet/snippetContext';
// import { GeoBase } from '@search/vtbeco-frontend-core/domain/geo/GeoBase';
import {
    useOfferFiltersDesktop
} from '@search/vtbeco-frontend-core/domain/offer/filters/useOfferFiltersDesktop';
import {
    useOfferSearchPageState2
} from '@search/vtbeco-frontend-core/domain/offer/search/page/useOfferSearchPageState2';
import { RegionIdEnum } from '@search/vtbeco-frontend-core/enums';
import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { formatNumber } from '@search/helpers/src/formatNumber';
import { ISearchType, SearchMapRoute, SearchRoute, useRouter } from '@search/offer-search-routes/src';
import { Filters, RegionFilter, MortgagePaymentFilter } from '@search/vtbeco-frontend-core/view/filters/models/Filter';
import { SaveSearch } from '@search/classified-common/src/SaveSearch';
import { useSaveSearchState } from '@search/classified-common/src/SaveSearch/useSaveSearchState';
import { CustomerFeedback } from '@search/vtbeco-frontend-core/view/common/components/CustomerFeedback';
// import { SubscribeModalIdle } from '@search/vtbeco-frontend-core/view/common/components/SubscribeToSearch/components/SubscribeModalIdle';
import { offerFilterGqlFromRoute } from '@search/vtbeco-frontend-core/domain/offer/search/page/offerFilterGqlFromRoute';
import { useIdle } from '@search/vtbeco-frontend-core/view/common/hooks/useIdle';
import Breadcrumb from '@search/vtbeco-ui/src/components/Breadcrumb';
import classname from '@search/classname/src';
// import { OfferSeoTagRecommends } from '@search/vtbeco-frontend-core/domain/offer/seoTag/OfferSeoTagRecommends';
// import { OfferSeoTagCatalog } from '@search/vtbeco-frontend-core/domain/offer/seoTag/OfferSeoTagCatalog';
import { ClSerpSummary } from '@search/classified-common/src/ClSerpSummary';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
// import { ClOffersFAQ } from '@search/classified-common/src/ClOffersFAQ/ClOffersFAQ';
import { CALLTOUCH_ID, useCalltouch } from '@search/classified-common/src/scripts/useCalltouch';
import NewBuildingQuiz from '@search/nb-quiz/src/components/common/NewBuildingQuiz';
import { CoreSvgSpriteIcon } from '@search/vtbeco-frontend-core/view/common/components/CoreSvgSpriteIcon/CoreSvgSpriteIcon';
// import { ClPromoRieltorsTrigger } from '@search/classified-common/src/ClPromoRieltorsTrigger/ClPromoRieltorsTrigger';

import {
    MortgageStupidModal
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/stupid/MortgageStupidModal';
import { priceByMortgagePayment } from '@search/vtbeco-frontend-core/view/filters/helpers/priceHelper';
import { OffersSearchFilters } from './OffersSearchFilters';
import { OffersSearchList } from './OffersSearchList';

import SerpSprite from '-!svg-react-loader!@search/classified-common/src/sprites/serpSprite.svg';

const NewBuildingSnippet: React.FC<NewBuildingBaseSnippetProps> = props => {
    return (
        <NewBuildingBaseSnippet {...props} />
    );
};

export const cnOffersSearch = classname.bind(null, 'OffersSearch');

// eslint-disable-next-line complexity
export const OffersSearch = React.memo(errorCatcherWrap(function OffersSearch() {
    useCalltouch();
    const router = useRouter();
    const searchRoute = router.route(SearchRoute);
    const searchParams = searchRoute.params();
    const searchMapRoute = router.route(SearchMapRoute);
    const gqlFilters = offerFilterGqlFromRoute(searchParams);

    const isMapSearch = Boolean(searchParams.mapBounds?.bounds);

    const {
        collection, emptyResultTitle, pagination, geoStore, rootRegion, count, loading, filters, sort, pageNumber,
        similarNbCollection,
        // seoTags,
        pageSize,
        mortgageBannerMinutesVariant,
        mortgageBannerTextVariant,
        updateFilters,
        handlePageChange,
        handleChangeSort,
        handleReset,
        handleResetInSegment,
        handleShowMore,
        handleClickOnBreadcrumb,
        addQueryDisplayValue,
        queryDisplayValues,
        headerTitle,
        hasOfferWithoutVas,
        userId,
        userPhone,
        sortValues,
        isNeedPagination,
        newBuilding,
        clearCache,
        summary,
        // faqTexts,
        showMortgageBanner,
        estimatePrice,
        isRealtorAuthorFilterActive,
        breadcrumbSections,
        mortgagePurpose,
        onSwitchToNb,
        showPromoRieltors,
        lastSearches,
        openQuizModal,
        isQuizModalOpen,
        closeQuizModal,
        showNbQuiz,
        mortgagePaymentSearchInfoModal,
        sendMortgageModal,
        closePaymentInfoModal,
        closeSendMortgageModal,
        openMortgagePaymentSearchModal,
        minimalMortgageRate
    } = useOfferSearchPageState2(searchRoute);

    const {
        isOpenSaveSearch,
        openSaveSearch,
        closeSaveSearch
    } = useSaveSearchState();

    const {
        handleResetNoGeo,
        removeFilter,
        updateFewFilters,
        updateFilter,
        removeGeo,

        extraFilterVisible,
        closeExtraVisible,
        openExtraFilter,

        tipsExpanded,
        setTipsExpanded,
        tipsVisible,
        setTipsVisible
    } = useOfferFiltersDesktop({
        updateFilters,
        filters,
        geoStore,
        queryDisplayValues
    });

    // comment for ci start
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const regionId = (filters.get(Filters.region) as RegionFilter).region ?? RegionIdEnum.MSK;

    // const geo = React.useMemo(() => {
    //     const geoBase = new GeoBase(regionId);
    //
    //     geoBase.store = geoStore;
    //
    //     return geoBase;
    // }, [ regionId, geoStore ]);

    const handleSubmit = useCallback((needClear?: boolean) => {
        closeExtraVisible();

        if (needClear) clearCache(true);
    }, [ closeExtraVisible, clearCache ]);

    const handleChangePagination = useCallback((pageNum: number, event?: React.MouseEvent) => {
        event?.preventDefault();

        window.scrollTo(0, 0);

        handlePageChange(pageNum);
    }, [ handlePageChange ]);

    const buildPageUrl = useCallback((pageNum: number) =>
        searchRoute.url({ ...searchParams, pageNumber: pageNum }),
    [ searchRoute, searchParams ]);

    const onSwitchClick = useCallback((id: string) => {
        if (id === 'map') {
            searchMapRoute.push({
                ...searchParams,
                pageNumber: undefined,
                sort: undefined,
                mapBounds: {
                    ...searchParams.mapBounds,
                    geohash: undefined
                }
            });
        }
        if (id === 'list') {
            searchRoute.push({ ...searchParams });
        }
    }, [ searchMapRoute, searchParams, searchRoute ]);

    const handleMapSearch = useCallback(() => {
        onSwitchClick('map');
        dataLayerPush({ event: 'classified_serp_click_to_map' });
    }, [ onSwitchClick, dataLayerPush ]);

    const { disableIdle } = useIdle({
        rememberKey: 'isSubscriptionWasShown',
        idleTimeout: 30
    });

    const serpContentRef = useRef<HTMLDivElement>(null);

    const realtyType = useMemo(() => {
        if (filters.isFlatFilterActive()) return 'ProfOfferFlat';
        if (filters.isHouseFilterActive()) return 'ProfOfferHouse';
        if (filters.isLandFilterActive()) return 'ProfOfferLand';

        return 'ProfOfferRoom';
    }, [ filters ]);

    return (
        <>
            <div className='SerpSprite' style={{ display: 'none' }}>
                <SerpSprite />
            </div>
            <OffersSearchFilters
                onSaveSearch={openSaveSearch}
                serpContentRef={serpContentRef}
                loading={loading}
                geoStore={geoStore}
                filters={filters}
                updateFilter={updateFilter}
                updateFewFilters={updateFewFilters}
                openExtraFilter={openExtraFilter}
                closeExtraVisible={closeExtraVisible}
                extraFilterVisible={extraFilterVisible}
                handleSubmit={handleSubmit}
                count={count}
                setTipsVisible={setTipsVisible}
                tipsVisible={tipsVisible}
                setTipsExpanded={setTipsExpanded}
                tipsExpanded={tipsExpanded}
                handleReset={handleResetNoGeo}
                handleResetGeo={handleResetInSegment}
                removeFilter={removeFilter}
                removeGeo={removeGeo}
                queryDisplayValues={queryDisplayValues}
                addQueryDisplayValue={addQueryDisplayValue}
                handleMapSearch={handleMapSearch}
                lastSearches={lastSearches}
                showPromoRieltors={showPromoRieltors}
                openMortgagePaymentSearchModal={openMortgagePaymentSearchModal}
                regionId={regionId}
                rootRegion={rootRegion}
            />
            <div className={cnOffersSearch()} ref={serpContentRef}>
                {
                    pageNumber === 1 && newBuilding ? (
                        <div className={cnOffersSearch('newBuilding')}>
                            <SnippetProviderContext>
                                <NewBuildingSnippet
                                    newBuilding={newBuilding}
                                    calltouchId={CALLTOUCH_ID}
                                    gtmClick='cl_ToNB_SERP_wizzard_block'
                                />
                            </SnippetProviderContext>
                        </div>
                    ) : null
                }

                <div className={cnOffersSearch('breadcrumb')}>
                    <Breadcrumb
                        onClick={handleClickOnBreadcrumb}
                        sections={breadcrumbSections}
                    />
                </div>

                {headerTitle && (
                    <Typography
                        tag='h1'
                        variant='h1'
                        className={cnOffersSearch('title')}
                    >
                        {isMapSearch ? `${headerTitle.split(' в')[0]} в выделенной области` : headerTitle}
                    </Typography>
                )}

                <div className={cnOffersSearch('sorter')}>
                    <div className={cnOffersSearch('sorter')}>
                        <div className={cnOffersSearch('sorterSelect')}>
                            <Select<NonNullable<ISearchType['sort']>>
                                name='sort'
                                dataTest='sort'
                                size='s'
                                mode='single'
                                disabled={loading || collection.length === 0}
                                options={sortValues.map(el => ({
                                    value: el.value as NonNullable<ISearchType['sort']>,
                                    content: el.label,
                                    text: `Сортировка: ${el.label.toLocaleLowerCase()}`,
                                }))}
                                value={sort}
                                onChange={handleChangeSort}
                                placement='local'
                            >Сортировка</Select>
                        </div>
                        <div className={cnOffersSearch('mapSwitch')}>
                            <Button
                                size='s'
                                onClick={() => {
                                    onSwitchClick('map');
                                    dataLayerPush({ event: 'classified_serp_click_to_map' });
                                }}
                                icon='map'
                                fullWidth
                                iconPosition='start'
                                variant='secondary'
                                dataTest='ymap-switch-map'
                            >
                                На карте
                            </Button>
                        </div>
                        {collection.length > 0 && (
                            <Typography
                                variant='primary'
                                color='secondary'
                                className={cnOffersSearch('totalItems')}
                            >
                                {
                                    formatNumber(count)
                                } {
                                    declensionByNumber(count, [ 'объявление', 'объявления', 'объявлений' ])
                                }
                            </Typography>
                        )}
                    </div>
                    {/*{showPromoRieltors && <ClPromoRieltorsTrigger regionId={regionId} view='btn' />}*/}
                    {showNbQuiz && (
                        <Button
                            variant='promo1'
                            size='s'
                            dataTest='quiz-btn-trigger'
                            onClick={openQuizModal}
                        >
                            <CoreSvgSpriteIcon
                                name='QuizFast'
                                width={24}
                                height={24}
                                style={{ position: 'absolute' }}
                            />
                            <span style={{ marginLeft: '32px' }}>
                                Быстрый подбор ЖК
                            </span>
                        </Button>
                    )}
                </div>
                {/*{seoTags?.recommended.length ? <OfferSeoTagRecommends*/}
                {/*    recommended={seoTags?.recommended ?? []}*/}
                {/*/> : null}*/}

                <OffersSearchList
                    disableIdle={disableIdle}
                    isCreatedAtVisible={searchParams.sort === 'date_asc' || searchParams.sort === 'date'}
                    loading={loading}
                    collection={collection}
                    emptyResultTitle={emptyResultTitle}
                    onResetFilters={handleReset}
                    regionId={regionId}
                    narrowRegionId={rootRegion?.narrowRegion?.id}
                    realtyType={realtyType}
                    estimatePrice={estimatePrice}
                    mortgageBannerMinutesVariant={mortgageBannerMinutesVariant}
                    mortgageBannerTextVariant={mortgageBannerTextVariant}
                    isSell={filters.isSellFilterActive()}
                    showMortgageBanner={showMortgageBanner}
                    isNewBuilding={filters.isNewBuilding()}
                    mortgagePurpose={mortgagePurpose}
                    hasOfferWithoutVas={hasOfferWithoutVas}
                    isRealtorAuthorFilterActive={isRealtorAuthorFilterActive}
                    userId={userId}
                    userPhone={userPhone}
                    openSaveSearch={openSaveSearch}
                    onSwitchToNb={onSwitchToNb}
                    similarNbCollection={similarNbCollection}
                    showPromoRieltors={showPromoRieltors}
                    isOnlySecondOffers={filters.isOnlySecond()}
                    minimalMortgageRate={minimalMortgageRate}
                    pageNumber={pageNumber}
                />

                {/*<SubscribeModalIdle*/}
                {/*    opened={isIdle}*/}
                {/*    onClose={disableIdle}*/}
                {/*    handleSaveSearch={openSaveSearch}*/}
                {/*/>*/}
                <div className={cnOffersSearch('pagination')}>
                    {/*<div className={cnOffersSearch('saveSearch')}>*/}
                    {/*    <Button*/}
                    {/*        fullWidth*/}
                    {/*        dataTest='save-search-serp'*/}
                    {/*        icon='magnifier-heart'*/}
                    {/*        onClick={() => {*/}
                    {/*            openSaveSearch();*/}
                    {/*            dataLayerPush({ event: 'classified_serp_click_save_search' });*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        Сохранить поиск*/}
                    {/*    </Button>*/}
                    {/*</div>*/}
                    {isNeedPagination ? (
                        <>
                            <div className={cnOffersSearch('pagination_more')}>
                                <Button
                                    dataTest='filter-more-show'
                                    onClick={() => handleShowMore()}
                                    variant='secondary'
                                    disabled={loading || pagination.isLastPageNumber}
                                >
                                    Показать еще
                                </Button>
                            </div>
                            <Paginator
                                onChange={handleChangePagination}
                                page={pageNumber}
                                itemsPerPage={pageSize}
                                buildPageUrl={buildPageUrl}
                                totalItems={pagination.totalItems}
                            />
                        </>
                    ) : null}
                </div>
                <ClSerpSummary
                    count={summary?.count}
                    priceTo={summary?.priceRange?.to ?? '0'}
                    priceFrom={summary?.priceRange?.from ?? '0'}
                />
                {/*<OfferSeoTagCatalog geoStore={geo.store} seoTags={seoTags} h1Text={headerTitle} />*/}
                {/*{collection.length > 1 && ! emptyResultTitle && (*/}
                {/*    <ClOffersFAQ faqTexts={faqTexts} />*/}
                {/*)}*/}
                <CustomerFeedback applicationId={ApplicationIdEnum.ClassifiedDesktop} />
                {isOpenSaveSearch ? (
                    <SaveSearch
                        handleClose={closeSaveSearch}
                        searchTitle={headerTitle}
                        openSaveSearch={openSaveSearch}
                        gqlFilters={gqlFilters}
                    />
                ) : null}
                <DSModal
                    opened={isQuizModalOpen}
                    onClose={closeQuizModal}
                    size='l'
                >
                    <DSModal.Content>
                        <NewBuildingQuiz isInModal isClassified />
                    </DSModal.Content>
                </DSModal>
                <DSModal opened={mortgagePaymentSearchInfoModal} onClose={() => closePaymentInfoModal(false)}>
                    <Typography variant='primary' className={cnOffersSearch('modalInfo')}>
                        <span style={{ fontWeight: 'bold' }}>
                            Это ориентировочный расчет.&nbsp;
                        </span>
                        Чтобы подобрать актуальные объявления мы&nbsp;используем медианное значение ипотечной ставки, фиксированный срок&nbsp;&mdash; 30&nbsp;лет и&nbsp;первоначальный взнос&nbsp;&mdash; 20%. На&nbsp;основе этих данных прогнозируем сумму кредита, которую вам могут одобрить банки и&nbsp;показываем квартиры подходящие под эти параметры.
                        <br />
                        <br />
                        Чтобы узнать точную ставку, которую вам одобрят банки и&nbsp;получить дополнительную скидку&nbsp;&mdash; оставьте заявку.
                    </Typography>
                    <Button
                        variant='accent'
                        fullWidth
                        onClick={() => closePaymentInfoModal(true)}
                    >
                        Узнать свою ставку по ипотеке
                    </Button>
                </DSModal>
                {sendMortgageModal ? <MortgageStupidModal
                    isNewBuilding={false}
                    locationPlacement='промо-баннер'
                    applicationId={ApplicationIdEnum.ClassifiedTouch}
                    realtyType={null}
                    propertyCost={priceByMortgagePayment((filters.get(Filters.mortgagePayment) as MortgagePaymentFilter).payment ?? 70000)}
                    onClose={closeSendMortgageModal}
                    rate={0.2}
                    minimalMortgageRate={minimalMortgageRate?.secondaryMortgageRate}
                /> : null}
            </div>
        </>
    );
}));
